export default {"src":"/_next/static/media/lawn-removal.4db8201e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};